<template>
  <v-breadcrumbs
    v-show="hasBreadcrumb"
    :items="items"
    class="pa-0 mb-3"
  >
    <template v-slot:item="props">
      <v-btn
        small
        depressed
        rounded
        text
        class="bread-nav"
        @click="$router.go(-1)"
      >
        <v-icon small>
          arrow_back_ios
        </v-icon>
        {{ props.item.text }}
      </v-btn>
    </template>
  </v-breadcrumbs>
</template>
<style>
  .bread-nav{
    left: -12px;
  }
</style>
<script>
  import { isEmpty, get } from 'lodash'

  export default {
    data() {
      return {
        model: {
          text: get(this.$route, 'meta.breadcrumb.text', ''),
          disabled: get(this.$route, 'meta.breadcrumb.disabled', false),
          routeName: get(this.$route, 'meta.breadcrumb.routeName', ''),
        },
      }
    },

    computed: {
      items() {
        return [ this.model ]
      },
      hasBreadcrumb() {
        return !isEmpty(this.model.text)
      }
    },
    watch: {
      '$route': (to, from) => {
        // react to route changes...
        if (to.meta.breadcrumb) {
          this.model = { ...to.meta.breadcrumb }
        }

      }
    },
  }
</script>
